import React, { useCallback, useEffect, useState } from 'react'
import HeaderList from '../../components/HeaderList'
import ParamsUi from './components/ParamsUi'
import { useDispatch, useSelector } from 'react-redux';
import { selectUser } from "../../redux/slices/user";
import { getAllParameters, getVoucheriPromo, sendParameters, selectListParams, selectListPromosBin } from "../../redux/slices/params";
import { message } from 'antd';

const Main = () => {
  const dispatch = useDispatch();
  const user = useSelector(selectUser);
  const parameters = useSelector(selectListParams);
  const binpromos = useSelector(selectListPromosBin);
  const [loading, setLoading] = useState(true);
  
  const initialFetch = useCallback(async () => {
    setLoading(true);
    const response = await dispatch(getAllParameters(user.id));
    const response_bin = await dispatch(getVoucheriPromo(user.id));
    if (response.status !== "success" && response_bin.status === "success") {
      message.error("¡Hubo un problema!");
    }
    setLoading(false);
  }, [dispatch, user]);

  useEffect(() => {
    initialFetch();
  }, [initialFetch]);

  const onFinishParams = async (values) => {
    try {
      setLoading(true);
      const response = await dispatch(sendParameters(user.id, values));
      if (response.status === "success") {
        message.success("Configuración Guardada con éxito");
      } else {
        message.error("¡Hubo un problema! Inténtalo de nuevo");
      }
    } catch (error) {
      message.error("¡Hubo un problema! Inténtalo de nuevo");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div>
        <HeaderList title={'Parámetros'} back={'/ajustes'} />
        <ParamsUi loading={loading} listparams={parameters} listbinpromos={binpromos} sendParams={onFinishParams} userId={user.id} />
    </div>
  )
}

export default Main